export default __webpack_public_path__ + "static/media/thumb-3.02f0abb4.png";